import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { FetchTeamSubTeams, FetchTeamSubTeamsFailure, FetchTeamSubTeamsSuccess } from '../actions';

@Injectable()
export class TeamSubTeamsResolver  {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const teamId = route.params['teamId'];
        this._store.dispatch(new FetchTeamSubTeams({ teamId }));

        return this._actionHelper.race(FetchTeamSubTeamsSuccess, FetchTeamSubTeamsFailure);
    }
}
